import React from "react";
//This context is only used by the file upload view(s)
//It's only used to close all of the if one is closed
//The inital state is set to true, if it's set to false in any dialog boxes
//All child and parent dialog boxes are set to false and closed
export const FileUploadContext = React.createContext();
export default function ToggleFileUpload({ children }) {
  const [isOpen, setOpen] = React.useState(true);
  function close() {
    setOpen(false);
  }
  function getIsOpen() {
    return isOpen;
  }
  function toggleIsOpen() {
    setOpen((prev) => !prev);
  }
  const values = {
    close,
    getIsOpen,
    toggleIsOpen,
  };
  return (
    <FileUploadContext.Provider value={values}>
      {children}
    </FileUploadContext.Provider>
  );
}
